import api from "./api"; // centralized baseURL + JWT handling

// --------------------
// Users
// --------------------

export const getUsers = async () => {
  const res = await api.get("/users/");
  return res.data;
};

export const getCurrentUser = async () => {
  const res = await api.get("/users/me/");
  return res.data;
};

export const createUser = async (userData) => {
  /**
   * userData example:
   * {
   *   username,
   *   email,
   *   password,
   *   role,
   *   approver_level: 1 | 2 | null,
   *   department_id
   * }
   */
  const res = await api.post("/users/", userData);
  return res.data;
};

export const updateUser = async (id, userData) => {
  /**
   * userData example:
   * {
   *   role,
   *   approver_level: 1 | 2 | null,
   *   department_id
   * }
   */
  const res = await api.put(`/users/${id}/`, userData);
  return res.data;
};

export const deleteUser = async (id) => {
  await api.delete(`/users/${id}/`);
};
